import React, { useState } from 'react'
import { connect } from 'react-redux'
import browser from 'webextension-polyfill'
import Bookmark from '~co/bookmarks/edit'
import { DealCTA, DealChat } from '~modules/deals'
import Buttons from './buttons'

function ClipperContent({ item, deal, add_auto_save, add_default_collection, last_collection }) {
    const collectionId = add_default_collection||last_collection
    //view swap fallback: deal CTA ↔ discussion thread for the detected tool
    const [chatTarget, setChatTarget] = useState(null)

    //primary surface is the side panel — the discussion lives beside the
    //page, persistent across popup closes; swap inside the popup only when
    //the side-panel API isn't there (older vendors)
    const openChat = (target) => {
        const path = 'sidepanel.html#/extension/chat'
        const fallback = () => setChatTarget(target)
        //the panel scope-stamps the target with the tab+url it came from —
        //a stored target must never reopen on an unrelated page
        const stamp = (tab) => browser.storage.session.set({
            dealChatTarget: { ...target, tabId: tab?.id, url: tab?.url, at: Date.now() }
        })

        //Firefox: sidebarAction.open() is gesture-gated — awaiting anything
        //first (storage, tab lookup) voids it, so open() fires synchronously
        //inside the click handler and the rest is sequenced after; the tab-
        //scoped setPanel then navigates the open sidebar to the chat route
        if (browser.sidebarAction?.open) {
            browser.sidebarAction.open()
                .then(async () => {
                    const [tab] = await browser.tabs.query({ active: true, currentWindow: true })
                    await stamp(tab)
                    if (tab?.id != null)
                        await browser.sidebarAction.setPanel({ tabId: tab.id, panel: path })
                })
                .catch(fallback)
            return
        }

        //Chromium/Edge: transient activation survives awaits for sidePanel
        ;(async () => {
            try {
                const [tab] = await browser.tabs.query({ active: true, currentWindow: true })
                await stamp(tab)
                if (browser.sidePanel?.open && tab) {
                    await browser.sidePanel.setOptions({ tabId: tab.id, path, enabled: true })
                    //tab-scoped: other tabs in the window keep the default panel
                    await browser.sidePanel.open({ tabId: tab.id })
                    return
                }
            } catch(e) {}
            fallback()
        })()
    }

    return (
        <>
        {chatTarget
            ? <DealChat target={chatTarget} onBack={() => setChatTarget(null)} />
            : (deal?.url ? <DealCTA deal={deal} onDiscuss={openChat} /> : null)}
        <Bookmark
            _id={item.link}

            new={{
                item: {
                    ...item,
                    collectionId
                },
                //preventDuplicate: false,
                autoCreate: add_auto_save
            }}

            autoFocus='note'
            autoWindowClose

            buttons={
                <Buttons
                    link={item.link}
                    collectionId={collectionId} />
            } />
        </>
    )
}

export default connect(
    ({ config: { add_auto_save, add_default_collection, last_collection } })=>({
        add_auto_save,
        add_default_collection,
        last_collection
    })
)(ClipperContent)
